import { Reveal } from "./Reveal";
import { CLEANERS } from "./data";
import { ShieldCheck } from "lucide-react";

export const Team = () => (
  <section id="cleaners" aria-labelledby="cleaners-heading" className="py-16 md:py-24 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <span className="text-sm font-bold uppercase tracking-wide text-brand-accentink">Meet the people</span>
            <h2 id="cleaners-heading" className="mt-3 font-heading font-extrabold tracking-tight text-3xl md:text-4xl text-brand-blue">The cleaners who care for your home</h2>
          </div>
          <p className="flex items-center gap-2 max-w-sm text-brand-ink2 leading-relaxed">
            <ShieldCheck className="h-5 w-5 text-brand-green shrink-0" strokeWidth={2} aria-hidden="true" />
            Every cleaner is police-checked, fully insured and trained to our eco-friendly standard.
          </p>
        </div>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
        {CLEANERS.map((c, i) => (
          <Reveal key={c.id} delay={0.05 * i} className={c.span}>
            <figure data-testid={`cleaner-${c.id}`} className="group relative rounded-3xl overflow-hidden h-72 md:h-80 shadow-[0_12px_36px_rgba(2,71,157,0.08)]">
              <img src={c.src} alt={`${c.name}, ${c.role} at Aid in Clean`} className="absolute inset-0 h-full w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/75 via-brand-ink/10 to-transparent" />
              <figcaption className="absolute bottom-5 left-5 right-5">
                <span className="block font-heading font-bold text-white text-xl">{c.name}</span>
                <span className="inline-block mt-1 rounded-full bg-brand-green px-3 py-0.5 text-xs font-bold text-brand-ink">{c.role}</span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
